
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component({})
  export default class AppMenuBtn extends Vue {
    @Prop() value: boolean;
    @Prop() mobile: boolean;

    clickHandler() {
      this.$emit('input', !this.value);
    }
  }
